import React from 'react';
import {useSelector} from 'react-redux';

import AemComponent from '@/components/Aem/AemComponent/AemComponent';
import EditableText from '@/components/Aem/EditableText/EditableText';
import {AppButton} from '@/components/Button';
import * as advanceDiagnosticIconTypes from '@/consts/advanceDiagnostic/advanceDiagnosticIconTypes';
import * as advanceDiagnosticScreenTypes from '@/consts/advanceDiagnostic/advanceDiagnosticScreenTypes';
import {
    ADVANCED_DIAGNOSTICS_CHARGING_ISSUE_BUTTON_ARIA_LABEL,
    ADVANCED_DIAGNOSTICS_CHARGING_ISSUE_NOT_NOW_BUTTON_ARIA_LABEL,
} from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import {getAriaLabel} from '@/services/accessibilityService';
import amplitudeADTracking from '@/services/analytics/amplitude/amplitudeADTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import appRouterService from '@/services/route/appRouterService';

import AdvancedDiagnosticDescription from '../components/AdvancedDiagnosticDescription';
import AdvancedDiagnosticIcon from '../components/AdvancedDiagnosticIcon';
import AdvancedDiagnosticLayout from '../components/AdvancedDiagnosticLayout';
import AdvancedDiagnosticTitle from '../components/AdvancedDiagnosticTitle';
import NotNowButtonAD from '../components/NotNowButtonAD';
import {selectDiagnosticFlowDataResult} from '../state/advancedDiagnosticSelectors';

const AdvancedDiagnosticChargingIssue = () => {
    const diagnosticResult = useSelector(selectDiagnosticFlowDataResult);
    const {deviceInferenceCode, holderInferenceCode} = diagnosticResult || {};
    const inferenceCode = deviceInferenceCode ? deviceInferenceCode : holderInferenceCode;
    const isHolder = inferenceCode === holderInferenceCode;
    const onCleanMyDeviceButtonClick = () => {
        amplitudeADTracking.trackADCleanMyDeviceClick();
        googleAnalyticsService.trackAdCleanMyDeviceClick();
        appRouterService.forwardToCleaningContactsScreenAD();
    };

    return (
        <AdvancedDiagnosticLayout>
            <AdvancedDiagnosticLayout.ContentWrapper>
                <AdvancedDiagnosticLayout.Container sectionClassName='h-full'>
                    <div className='flex h-full flex-col justify-between ml:px-0'>
                        <div className='flex flex-1 flex-col items-center justify-center'>
                            <AdvancedDiagnosticIcon type={advanceDiagnosticIconTypes.ERROR} />
                            <AdvancedDiagnosticTitle itemName='chargingissuetitle' />
                            <AdvancedDiagnosticDescription itemName='chargingissuedesc' />
                        </div>

                        <div className='mt-10 grid w-full grid-cols-1 justify-items-center gap-4 ml:mt-8 ml:gap-3'>
                            <AppButton
                                primary
                                light
                                className='mt-0 w-full'
                                onClick={onCleanMyDeviceButtonClick}
                                aria-label={getAriaLabel(ADVANCED_DIAGNOSTICS_CHARGING_ISSUE_BUTTON_ARIA_LABEL)}
                            >
                                <AemComponent
                                    component={EditableText}
                                    pageName={routePaths.ADVANCE_DIAGNOSTIC}
                                    itemName='chargingissuebutton'
                                />
                            </AppButton>
                            <NotNowButtonAD
                                className='ml:w-full'
                                isHolder={isHolder}
                                inferenceCode={inferenceCode}
                                screenName={advanceDiagnosticScreenTypes.CHARGING_ISSUE_SCREEN}
                                aria-label={getAriaLabel(ADVANCED_DIAGNOSTICS_CHARGING_ISSUE_NOT_NOW_BUTTON_ARIA_LABEL)}
                            >
                                <AemComponent
                                    component={EditableText}
                                    pageName={routePaths.ADVANCE_DIAGNOSTIC}
                                    itemName='chargingissuenotnowbutton'
                                />
                            </NotNowButtonAD>
                        </div>
                    </div>
                </AdvancedDiagnosticLayout.Container>
            </AdvancedDiagnosticLayout.ContentWrapper>
        </AdvancedDiagnosticLayout>
    );
};

export default AdvancedDiagnosticChargingIssue;
